import { Dispatch } from 'redux';
import { AppState } from '../types/app-state';
import { Action } from '../types/action';
import { Organisation } from '../types/organisation';
import { getAllOrganisations } from '../services/organisation';
import { InviteUserItem } from '../types/inviteuser-item';
import { inviteUsers } from '../services/invitation';
import * as Constants from './inviteusers.constants';

export interface SetErrorMessageAction extends Action {
  message: string;
}

export interface LoadOrganisationsDoneAction extends Action {
  organisations: Organisation[];
}

export interface UpdateSelectedOrganisationIdAction extends Action {
  id: string;
}

export interface AddUserAction extends Action {
  user: InviteUserItem;
}

export interface RemoveUserAction extends Action {
  email: string;
}

export function Initialize(initialOrgId: string) {
  return async (dispatch: Dispatch<any>) => {
    dispatch({ type: Constants.INITIALIZE });
    dispatch(LoadOrganisations());
    if (initialOrgId) {
      dispatch(UpdateSelectedOrganisationId(initialOrgId));
    }
  };
}

export function Destroy() {
  return async (dispatch: Dispatch<any>) => {
    dispatch({ type: Constants.DESTROY });
  };
}

export function LoadOrganisations() {
  return async (dispatch: Dispatch<any>, getState: () => AppState) => {
    dispatch({ type: Constants.LOAD_ORGANISATIONS });
    try {
      const { token } = getState().auth;

      if (token) {
        const { status, data, message } = await getAllOrganisations(token);
        if (status === 1 && data) {
          dispatch(LoadOrganisationsDone(data));
        } else {
          throw new Error(status === -2 ? 'A server error occurred' : message);
        }
      } else {
        throw new Error('User not authenticated');
      }

    } catch (error) {
      dispatch(SetErrorMessage(error.message));
    }
  };
}

export function LoadOrganisationsDone(organisations: Organisation[]): LoadOrganisationsDoneAction {
  return {
    type: Constants.LOAD_ORGANISATIONS_DONE,
    organisations
  };
}

export function SetErrorMessage(message: string): SetErrorMessageAction {
  return {
    type: Constants.SET_ERROR_MESSAGE,
    message
  };
}

export function UpdateSelectedOrganisationId(id: string): UpdateSelectedOrganisationIdAction {
  return {
    type: Constants.UPDATE_SELECTED_ORGANISATION_ID,
    id
  };
}

export function AddUser(user: InviteUserItem): AddUserAction {
  return {
    type: Constants.ADD_USER,
    user
  };
}

export function RemoveUser(email: string): RemoveUserAction {
  return {
    type: Constants.REMOVE_USER,
    email
  };
}

export function SubmitInvite() {
  return async (dispatch: Dispatch<any>, getState: () => AppState) => {
    dispatch({ type: Constants.SUBMIT_INVITE });
    try {
      const { token } = getState().auth;
      const { selectedOrganisationId, list } = getState().inviteusers;

      if (token && selectedOrganisationId && (list || []).length > 0) {
        const { status, message } = await inviteUsers(token, selectedOrganisationId, list || []);
        if (status === 1) {
          dispatch(SubmitInviteDone());
        } else {
          throw new Error(status === -2 ? 'A server error occurred' : message);
        }
      }
    } catch (error) {
      dispatch(SetErrorMessage(error.message));
    }
  };
}

export function SubmitInviteDone(): Action {
  return {
    type: Constants.SUBMIT_INVITE_DONE
  };
}

export type All
  = Action
  | LoadOrganisationsDoneAction
  | UpdateSelectedOrganisationIdAction
  | AddUserAction
  | RemoveUserAction
  | SetErrorMessageAction;